import React, { Component } from "react";
import {
  Container,
  Table,
  Row,
  Col,
  Navbar,
  Button,
  Nav,
  Form,
  ButtonToolbar,
} from "react-bootstrap";
import { faArrowLeft, faPlus, faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import TableLoader from "../../../components/extensions/TableLoader";

import {
  GetBranchCategoryCollection,
  GetSingleBranchCategory,
  AddBranchCategory,
  UpdateBranchCategory,
  DeleteBranchCategory,
} from "../../../store/actions/settings/settings_branch_category_service_actions";
import moment from "moment";

import { openModal, closeModal } from "../../../store/actions/ModalActions";
import ManageBranchCategorySettings from "./manage_branch_category_settings";
import { toastr } from "react-redux-toastr";
import { numberWithCommas } from "../../../helpers/dataHelpers";

class BranchCategorySettings extends Component {
  state = {
    isLoading: false,
    list: [],
  };

  _refresh = () => {
    this.setState({ isLoading: true });
    this.props.GetBranchCategoryCollection().then((resp) => {
      if (resp.problem === null) {
        this.setState({ list: resp.data, isLoading: false });
      }
    });
  };

  _deleteBranchCategory = (id) => {
    return this.props.DeleteBranchCategory({ id: id }).then((resp) => {
      if (resp.problem === null) {
        this._refresh();
        closeModal();
        toastr.success("Deleted", "Branch Category Deleted");
      }
    });
  };

  _addBranchCategory = (data) => {
    return this.props.AddBranchCategory(data).then((resp) => {
      if (resp.problem === null) {
        this._refresh();
        closeModal();
        toastr.success("Added", "Branch Category Added");
      }
    });
  };

  _editBranchCategory = (data) => {
    return this.props.UpdateBranchCategory(data).then((resp) => {
      if (resp.problem === null) {
        this._refresh();
        closeModal();
        toastr.success("Modified", "Branch Category Modified");
      }
    });
  };

  componentDidMount() {
    this._refresh();
  }

  renderTable() {
    return this.state.isLoading ? (
      <TableLoader />
    ) : (
      <Table hover striped variant="light" responsive>
        <thead>
          <th>Name</th>
          <th>Maximum</th>
          <th>Created on</th>
          <th />
        </thead>
        <tbody>
          {this.state.list.map((item, idx) => {
            return (
              <tr key={idx}>
                <td>{item.name}</td>
                <td>{numberWithCommas(item.maximum)}</td>
                <td> {moment(item.createdOn).format("MMMM DD YYYY")}</td>
                <td>
                  <ButtonToolbar className="float-right">
                    <Button
                      onClick={() => {
                        openModal({
                          title: "Modify Branch Category Setting",
                          currentComponent: (
                            <ManageBranchCategorySettings
                              data={item}
                              mode="Edit"
                              edit={this._editBranchCategory}
                            />
                          ),
                        });
                      }}
                      className="m-1"
                      variant="warning"
                    >
                      Edit
                    </Button>
                    <Button
                      className="m-1"
                      variant="danger"
                      onClick={() => {
                        toastr.confirm(
                          <p>
                            Are you sure you want to delete branch category{" "}
                            <strong className="strong">{item.name}</strong>?
                          </p>,
                          {
                            okText: "Yes, Delete",
                            onOk: () => {
                              this._deleteBranchCategory(item.id);
                            },
                          }
                        );
                      }}
                    >
                      Delete
                    </Button>
                  </ButtonToolbar>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  renderOptions = () => {
    return (
      <Navbar className="rounded">
        <Navbar.Brand>
          <Link className="mr-2" to="/pawnshop-reports/settings">
            <Button variant="outline-secondary">
              <FontAwesomeIcon icon={faArrowLeft} />
            </Button>
          </Link>
          Branch Categories
        </Navbar.Brand>
        <Navbar.Collapse>
          <Nav className="mr-auto" />
        </Navbar.Collapse>
        <Form inline>
          <Button
            onClick={() => {
              this._refresh();
            }}
            className="m-1"
            size="md"
            variant="primary"
          >
            <FontAwesomeIcon icon={faSync} className="mr-1" />
            Refresh
          </Button>
          <Button
            onClick={() => {
              openModal({
                title: "Create Branch Category Setting",
                currentComponent: (
                  <ManageBranchCategorySettings
                    add={this._addBranchCategory}
                    mode="Add"
                  />
                ),
              });
            }}
            className="m-1"
            size="md"
            variant="success"
          >
            <FontAwesomeIcon icon={faPlus} className="mr-1" />
            Create Branch Category Setting
          </Button>
        </Form>
      </Navbar>
    );
  };

  render() {
    return (
      <Container fluid className="bg-white p-3 shadow rounded">
        <Row>
          <Col>{this.renderOptions()}</Col>
        </Row>
        <Row>
          <Col>{this.renderTable()}</Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  GetBranchCategoryCollection: GetBranchCategoryCollection,
  GetSingleBranchCategory: GetSingleBranchCategory,
  AddBranchCategory: AddBranchCategory,
  UpdateBranchCategory: UpdateBranchCategory,
  DeleteBranchCategory: DeleteBranchCategory,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BranchCategorySettings);
